[
  {
    "id": 20001,
    "title": "Commercial Display 43in",
    "slug": "commercial-display-43in",
    "summary": "A 43-inch commercial-grade display option for menu boards, lobbies, and internal communications where reliability matters more than consumer TV shortcuts.",
    "descriptionHtml": "<p>A 43-inch commercial signage display designed for daily operation in business environments. Suitable for lobbies, menus, wayfinding, employee messaging, and branded in-store communication.</p><ul><li>43-inch 4K panel</li><li>Commercial-duty runtime</li><li>HDMI, USB, and network connectivity</li><li>Compatible with wall mounts, kiosks, and media players</li></ul>",
    "price": 899,
    "regularPrice": 899,
    "salePrice": null,
    "categories": ["Displays", "Commercial Displays", "Business", "Retail", "Lobbies"],
    "tags": ["display", "43-inch", "commercial"],
    "image": "/wordpress-media/023-LG-43UH5F-H-43in-Front.png",
    "attributes": {
      "size": "43in",
      "resolution": "4K",
      "orientation": "Landscape or portrait"
    },
    "taxonomy": {
      "catalogGroup": "Displays",
      "productFamily": "Commercial Displays",
      "deploymentContexts": ["Business", "Retail", "Lobbies"],
      "hardwareTypes": ["Display"],
      "capabilities": ["4K", "Commercial Runtime"]
    }
  },
  {
    "id": 20002,
    "title": "Commercial Display 55in",
    "slug": "commercial-display-55in",
    "summary": "A larger-format commercial display option for high-visibility messaging, directories, and branded customer touchpoints.",
    "descriptionHtml": "<p>A 55-inch commercial signage display intended for installations that need stronger visual presence from a longer distance.</p><ul><li>55-inch 4K panel</li><li>Commercial-duty runtime</li><li>Ideal for directories, menu boards, and customer communications</li></ul>",
    "price": 1299,
    "regularPrice": 1299,
    "salePrice": null,
    "categories": ["Displays", "Commercial Displays", "Business", "Healthcare", "Directories"],
    "tags": ["display", "55-inch", "commercial"],
    "image": "/wordpress-media/100-CenturionDSG.jpg",
    "attributes": {
      "size": "55in",
      "resolution": "4K",
      "orientation": "Landscape or portrait"
    },
    "taxonomy": {
      "catalogGroup": "Displays",
      "productFamily": "Commercial Displays",
      "deploymentContexts": ["Business", "Healthcare", "Directories"],
      "hardwareTypes": ["Display"],
      "capabilities": ["4K", "Commercial Runtime"]
    }
  },
  {
    "id": 20003,
    "title": "High Bright Window Display",
    "slug": "high-bright-window-display",
    "summary": "A storefront-facing high-brightness display option for environments with glare, ambient daylight, or street-facing placement.",
    "descriptionHtml": "<p>Designed for bright retail and street-facing environments where standard indoor panels wash out. A strong option for promotions, menus, and exterior-facing advertising.</p><ul><li>High-bright commercial panel</li><li>Suitable for window-forward deployments</li><li>Supports promotional and branded content playback</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Displays", "High Bright Displays", "Retail", "Storefront", "Advertising"],
    "tags": ["high-bright", "window display", "retail"],
    "image": "/wordpress-media/071-MicrosoftTeams-image-3.jpg",
    "attributes": {
      "brightness": "High Bright",
      "placement": "Window-facing"
    },
    "taxonomy": {
      "catalogGroup": "Displays",
      "productFamily": "High Bright Displays",
      "deploymentContexts": ["Retail", "Storefront", "Advertising"],
      "hardwareTypes": ["Display"],
      "capabilities": ["Daylight Visibility", "Promo Content"]
    }
  },
  {
    "id": 20004,
    "title": "BrightSign HD Media Player",
    "slug": "brightsign-hd-media-player",
    "summary": "A dedicated signage player for reliable playback, scheduled content, and cleaner installs than using a generic consumer device.",
    "descriptionHtml": "<p>A dedicated media player for commercial signage deployments where stable playback and easier management matter.</p><ul><li>Purpose-built signage playback</li><li>Supports scheduled content</li><li>Works with common signage display deployments</li></ul>",
    "price": 425,
    "regularPrice": 425,
    "salePrice": null,
    "categories": ["Media Players", "BrightSign Players", "Business", "Menus", "Retail"],
    "tags": ["media player", "brightsign"],
    "image": "/wordpress-media/021-HO523-HD-OPS.png",
    "attributes": {
      "playback": "HD",
      "connectivity": "HDMI, Ethernet, USB"
    },
    "taxonomy": {
      "catalogGroup": "Media Players",
      "productFamily": "BrightSign Players",
      "deploymentContexts": ["Business", "Menus", "Retail"],
      "hardwareTypes": ["Media Player"],
      "capabilities": ["Scheduled Playback", "Commercial Signage"]
    }
  },
  {
    "id": 20005,
    "title": "Android Signage Media Player",
    "slug": "android-signage-media-player",
    "summary": "A flexible Android-based playback option for lighter deployments, app-based signage workflows, and simpler content stacks.",
    "descriptionHtml": "<p>An Android signage player suited to app-driven or lightweight deployments where flexibility and lower upfront cost matter.</p><ul><li>Android signage playback</li><li>Good fit for simpler deployments</li><li>Supports app-based content workflows</li></ul>",
    "price": 189,
    "regularPrice": 189,
    "salePrice": null,
    "categories": ["Media Players", "Android Players", "Business", "Hospitality", "Retail"],
    "tags": ["android", "player", "signage"],
    "image": "/wordpress-media/021-HO523-HD-OPS.png",
    "attributes": {
      "platform": "Android",
      "connectivity": "HDMI, Wi-Fi, Ethernet"
    },
    "taxonomy": {
      "catalogGroup": "Media Players",
      "productFamily": "Android Players",
      "deploymentContexts": ["Business", "Hospitality", "Retail"],
      "hardwareTypes": ["Media Player"],
      "capabilities": ["App Playback", "Wi-Fi"]
    }
  },
  {
    "id": 20006,
    "title": "Low-Profile Wall Mount",
    "slug": "low-profile-wall-mount",
    "summary": "A simple fixed wall mount option for clean installations where the display can stay close to the wall plane.",
    "descriptionHtml": "<p>A low-profile wall mount for standard signage installs where a flush, simple installation is the goal.</p><ul><li>Fixed wall mount</li><li>Suitable for common commercial display sizes</li><li>Clean install footprint</li></ul>",
    "price": 89,
    "regularPrice": 89,
    "salePrice": null,
    "categories": ["Mounts", "Wall Mounts", "Business", "Retail"],
    "tags": ["mount", "wall mount"],
    "image": "/wordpress-media/024-LG-UP7670-43in-Black.png",
    "attributes": {
      "mountType": "Fixed",
      "vesa": "Universal"
    },
    "taxonomy": {
      "catalogGroup": "Mounts",
      "productFamily": "Wall Mounts",
      "deploymentContexts": ["Business", "Retail"],
      "hardwareTypes": ["Mount"],
      "capabilities": ["Low Profile", "Universal VESA"]
    }
  },
  {
    "id": 20007,
    "title": "Ceiling Mount Kit",
    "slug": "ceiling-mount-kit",
    "summary": "A suspended signage mount option for open spaces, corridors, and installs where wall placement is not ideal.",
    "descriptionHtml": "<p>A ceiling-mount option for digital signage in open spaces, walkways, waiting areas, and directional environments.</p><ul><li>Suspended signage mount</li><li>Suitable for directional and overhead visibility</li><li>Works well in open-floor environments</li></ul>",
    "price": 249,
    "regularPrice": 249,
    "salePrice": null,
    "categories": ["Mounts", "Ceiling Mounts", "Airport", "Wayfinding", "Healthcare"],
    "tags": ["ceiling mount", "wayfinding"],
    "image": "/wordpress-media/090-Brochure-Kiosk-Location.jpg",
    "attributes": {
      "mountType": "Ceiling",
      "orientation": "Landscape or portrait"
    },
    "taxonomy": {
      "catalogGroup": "Mounts",
      "productFamily": "Ceiling Mounts",
      "deploymentContexts": ["Airport", "Wayfinding", "Healthcare"],
      "hardwareTypes": ["Mount"],
      "capabilities": ["Overhead Visibility", "Open Floor Install"]
    }
  },
  {
    "id": 20008,
    "title": "Freestanding Kiosk Enclosure",
    "slug": "freestanding-kiosk-enclosure",
    "summary": "A kiosk enclosure option for interactive directories, visitor check-in, and self-service deployments in public-facing spaces.",
    "descriptionHtml": "<p>A freestanding kiosk enclosure designed for self-service and interactive signage deployments.</p><ul><li>Freestanding kiosk form factor</li><li>Suitable for touch displays and directories</li><li>Good fit for visitor check-in and self-service workflows</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Kiosks", "Freestanding Kiosks", "Business", "Healthcare", "Directories"],
    "tags": ["kiosk", "directory", "self-service"],
    "image": "/wordpress-media/104-kiosk-scaled.jpg",
    "attributes": {
      "formFactor": "Freestanding",
      "interaction": "Touch-ready"
    },
    "taxonomy": {
      "catalogGroup": "Kiosks",
      "productFamily": "Freestanding Kiosks",
      "deploymentContexts": ["Business", "Healthcare", "Directories"],
      "hardwareTypes": ["Kiosk"],
      "capabilities": ["Touch-Ready", "Self-Service"]
    }
  },
  {
    "id": 20009,
    "title": "Room Scheduling Panel",
    "slug": "room-scheduling-panel",
    "summary": "A compact panel option for meeting room availability, space booking, and workplace wayfinding at the room level.",
    "descriptionHtml": "<p>A compact room scheduling panel designed for workplace booking, room status, and availability workflows.</p><ul><li>Compact workplace panel</li><li>Meeting room scheduling use case</li><li>Good fit for offices and shared environments</li></ul>",
    "price": 625,
    "regularPrice": 625,
    "salePrice": null,
    "categories": ["Room Panels", "Scheduling Panels", "Business", "Meeting Rooms", "Workplace"],
    "tags": ["room panel", "scheduling"],
    "image": "/wordpress-media/094-MicrosoftTeams-image-29.png",
    "attributes": {
      "size": "Compact",
      "useCase": "Room scheduling"
    },
    "taxonomy": {
      "catalogGroup": "Room Panels",
      "productFamily": "Scheduling Panels",
      "deploymentContexts": ["Business", "Meeting Rooms", "Workplace"],
      "hardwareTypes": ["Panel"],
      "capabilities": ["Scheduling", "Availability Display"]
    }
  },
  {
    "id": 20010,
    "title": "Outdoor Signage Display Bundle",
    "slug": "outdoor-signage-display-bundle",
    "summary": "A broader outdoor-focused option for roadside, exterior, or weather-exposed digital signage deployments that need custom quoting.",
    "descriptionHtml": "<p>An outdoor signage bundle designed for deployments that need weather-aware hardware planning, brighter visuals, and a more tailored quote process.</p><ul><li>Outdoor deployment planning</li><li>Higher-brightness display strategy</li><li>Often paired with enclosure and permitting review</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Outdoor Solutions", "Outdoor Displays", "Advertising", "Wayfinding", "Retail"],
    "tags": ["outdoor", "display", "advertising"],
    "image": "/wordpress-media/072-New-Kit-web2.jpg",
    "attributes": {
      "environment": "Outdoor",
      "quoteType": "Custom"
    },
    "taxonomy": {
      "catalogGroup": "Outdoor Solutions",
      "productFamily": "Outdoor Displays",
      "deploymentContexts": ["Advertising", "Wayfinding", "Retail"],
      "hardwareTypes": ["Display", "Outdoor Kit"],
      "capabilities": ["Custom Quote", "Outdoor Planning"]
    }
  },
  {
    "id": 20011,
    "title": "Restaurant Menu Board Bundle",
    "slug": "restaurant-menu-board-bundle",
    "summary": "A restaurant-focused menu board bundle for pricing updates, promotions, and location-wide consistency across counter service environments.",
    "descriptionHtml": "<p>A menu board solution for restaurants, cafes, and food service environments that need cleaner pricing updates and more polished customer-facing presentation.</p><ul><li>Built for restaurant menu workflows</li><li>Supports promotions, combos, and rotating offers</li><li>Suitable for single or multi-screen menu layouts</li></ul>",
    "price": 2199,
    "regularPrice": 2199,
    "salePrice": null,
    "categories": ["Kiosks", "Deployment Kits", "Restaurant", "Hospitality", "Menus"],
    "tags": ["restaurant", "menu board", "hospitality"],
    "image": "/wordpress-media/075-menu-board-mock-up.jpg",
    "attributes": {
      "size": "43in or 55in",
      "layout": "Single or multi-screen"
    },
    "taxonomy": {
      "catalogGroup": "Kiosks",
      "productFamily": "Deployment Kits",
      "deploymentContexts": ["Restaurant", "Hospitality", "Menus"],
      "hardwareTypes": ["Kit", "Display"],
      "capabilities": ["Menu Boards", "Promo Scheduling"]
    }
  },
  {
    "id": 20012,
    "title": "Drive-Thru Confirmation Display",
    "slug": "drive-thru-confirmation-display",
    "summary": "A customer-facing display option for drive-thru confirmation, promotional messaging, and order visibility in quick-service lanes.",
    "descriptionHtml": "<p>A drive-thru signage option for QSR and food service environments that need customer-facing confirmation and clearer promotional messaging.</p><ul><li>Designed for drive-thru workflows</li><li>Supports confirmation and branded promo content</li><li>Typically part of a custom-quoted deployment</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Outdoor Solutions", "Outdoor Displays", "Restaurant", "Hospitality", "Advertising"],
    "tags": ["drive-thru", "restaurant", "outdoor"],
    "image": "/wordpress-media/107-MuckleshootMenu-rotated.jpeg",
    "attributes": {
      "environment": "Semi-outdoor or outdoor",
      "quoteType": "Custom"
    },
    "taxonomy": {
      "catalogGroup": "Outdoor Solutions",
      "productFamily": "Outdoor Displays",
      "deploymentContexts": ["Restaurant", "Hospitality", "Advertising"],
      "hardwareTypes": ["Display", "Outdoor Kit"],
      "capabilities": ["Order Confirmation", "Custom Quote"]
    }
  },
  {
    "id": 20013,
    "title": "Corporate Lobby Display Package",
    "slug": "corporate-lobby-display-package",
    "summary": "A polished lobby package for welcome messaging, company news, directories, and brand-forward first impressions in office environments.",
    "descriptionHtml": "<p>A lobby signage package for offices and corporate spaces that want a stronger visitor arrival experience and clearer internal communication.</p><ul><li>Ideal for lobbies and reception areas</li><li>Supports welcome, directory, and announcement content</li><li>Pairs well with mounts, media players, and branded templates</li></ul>",
    "price": 1899,
    "regularPrice": 1899,
    "salePrice": null,
    "categories": ["Displays", "Commercial Displays", "Business", "Lobbies", "Directories"],
    "tags": ["corporate", "lobby", "directory"],
    "image": "/wordpress-media/079-Products-in-the-boxBuisness-1.jpg",
    "attributes": {
      "size": "55in",
      "placement": "Lobby or reception"
    },
    "taxonomy": {
      "catalogGroup": "Displays",
      "productFamily": "Commercial Displays",
      "deploymentContexts": ["Business", "Lobbies", "Directories"],
      "hardwareTypes": ["Display"],
      "capabilities": ["Directories", "Welcome Messaging"]
    }
  },
  {
    "id": 20014,
    "title": "Employee Communications Network Bundle",
    "slug": "employee-communications-network-bundle",
    "summary": "A workplace communications bundle for HR updates, operations messaging, safety reminders, and internal engagement across multiple office zones.",
    "descriptionHtml": "<p>A workplace messaging bundle for internal communications across offices, campuses, and operations-heavy environments.</p><ul><li>Supports HR, operations, and safety messaging</li><li>Useful for multi-zone workplace rollout</li><li>Designed for recurring internal content updates</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Kiosks", "Deployment Kits", "Business", "Workplace", "Employee Messaging"],
    "tags": ["internal communications", "employee", "workplace"],
    "image": "/wordpress-media/099-ContiEmployeeComm-scaled.jpg",
    "attributes": {
      "rollout": "Single site or multi-zone",
      "content": "Recurring internal updates"
    },
    "taxonomy": {
      "catalogGroup": "Kiosks",
      "productFamily": "Deployment Kits",
      "deploymentContexts": ["Business", "Workplace", "Employee Messaging"],
      "hardwareTypes": ["Kit", "Display"],
      "capabilities": ["Employee Messaging", "Multi-Zone Rollout"]
    }
  },
  {
    "id": 20015,
    "title": "Classroom Presentation Display",
    "slug": "classroom-presentation-display",
    "summary": "An education-focused display option for classroom presentation, lesson support, and campus communications in K-12 and training environments.",
    "descriptionHtml": "<p>A display option for classrooms, training rooms, and education spaces that need reliable presentation hardware with straightforward deployment.</p><ul><li>Good fit for K-12 and training environments</li><li>Supports lesson content and room-level messaging</li><li>Works with standard wall-mount and player setups</li></ul>",
    "price": 1499,
    "regularPrice": 1499,
    "salePrice": null,
    "categories": ["Displays", "Commercial Displays", "Education", "Classrooms", "Training Rooms"],
    "tags": ["education", "classroom", "presentation"],
    "image": "/wordpress-media/103-WashPavVerticalPicture-scaled-1.jpg",
    "attributes": {
      "size": "65in",
      "resolution": "4K"
    },
    "taxonomy": {
      "catalogGroup": "Displays",
      "productFamily": "Commercial Displays",
      "deploymentContexts": ["Education", "Classrooms", "Training Rooms"],
      "hardwareTypes": ["Display"],
      "capabilities": ["Presentation", "Campus Messaging"]
    }
  },
  {
    "id": 20016,
    "title": "Campus Wayfinding Kiosk",
    "slug": "campus-wayfinding-kiosk",
    "summary": "A self-service kiosk option for campuses and larger facilities that need intuitive wayfinding, maps, and visitor navigation support.",
    "descriptionHtml": "<p>A wayfinding kiosk designed for larger campuses, multi-building facilities, and education environments where visitors need intuitive navigation support.</p><ul><li>Supports maps and directory content</li><li>Useful for campuses and shared facilities</li><li>Strong fit for public-facing self-service use</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Kiosks", "Freestanding Kiosks", "Education", "Wayfinding", "Directories"],
    "tags": ["campus", "wayfinding", "kiosk"],
    "image": "/wordpress-media/092-spaceage_visitorkiosk_2-1-of-1-scaled.jpg",
    "attributes": {
      "interaction": "Touch-ready",
      "placement": "Campus common areas"
    },
    "taxonomy": {
      "catalogGroup": "Kiosks",
      "productFamily": "Freestanding Kiosks",
      "deploymentContexts": ["Education", "Wayfinding", "Directories"],
      "hardwareTypes": ["Kiosk"],
      "capabilities": ["Touch-Ready", "Directories"]
    }
  },
  {
    "id": 20017,
    "title": "Healthcare Waiting Room Display",
    "slug": "healthcare-waiting-room-display",
    "summary": "A waiting room display option for patient education, queue updates, and care messaging in clinics and healthcare facilities.",
    "descriptionHtml": "<p>A healthcare signage option for waiting rooms and clinics that need patient education content, queue communication, and branded care messaging.</p><ul><li>Useful for clinics and waiting areas</li><li>Supports patient education and operational messaging</li><li>Fits common wall-mounted healthcare deployments</li></ul>",
    "price": 1399,
    "regularPrice": 1399,
    "salePrice": null,
    "categories": ["Displays", "Commercial Displays", "Healthcare", "Waiting Rooms", "Patient Communications"],
    "tags": ["healthcare", "waiting room", "patient"],
    "image": "/wordpress-media/082-Products-in-the-boxHospital-1.jpg",
    "attributes": {
      "size": "55in",
      "placement": "Waiting room"
    },
    "taxonomy": {
      "catalogGroup": "Displays",
      "productFamily": "Commercial Displays",
      "deploymentContexts": ["Healthcare", "Waiting Rooms", "Patient Communications"],
      "hardwareTypes": ["Display"],
      "capabilities": ["Patient Messaging", "Queue Updates"]
    }
  },
  {
    "id": 20018,
    "title": "Patient Room Door Sign",
    "slug": "patient-room-door-sign",
    "summary": "A compact room-level panel for patient room identification, care team messaging, and healthcare workflow visibility.",
    "descriptionHtml": "<p>A compact room-level panel designed for patient room identification and healthcare workflow support.</p><ul><li>Suitable for patient room and department-level use</li><li>Supports care team and status messaging</li><li>Useful for room-level operational visibility</li></ul>",
    "price": null,
    "regularPrice": null,
    "salePrice": null,
    "categories": ["Room Panels", "Scheduling Panels", "Healthcare", "Patient Communications", "Departments"],
    "tags": ["patient room", "panel", "healthcare"],
    "image": "/wordpress-media/063-Products-in-the-boxHospital.jpg",
    "attributes": {
      "size": "Compact",
      "placement": "Room-side"
    },
    "taxonomy": {
      "catalogGroup": "Room Panels",
      "productFamily": "Scheduling Panels",
      "deploymentContexts": ["Healthcare", "Patient Communications", "Departments"],
      "hardwareTypes": ["Panel"],
      "capabilities": ["Room Status", "Care Team Messaging"]
    }
  }
]